import { render } from "./VisualRecognitionAddNewSpecimen.vue?vue&type=template&id=1f751da6"
import script from "./VisualRecognitionAddNewSpecimen.vue?vue&type=script&lang=js"
export * from "./VisualRecognitionAddNewSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__